import { AnketaAnswerCheckboxes } from './AnketaAnswerCheckboxes';

export default AnketaAnswerCheckboxes;